import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { DateTimeTooltip } from "src/view/conponents/DateTimeTooltip";
import { formatDisplayDate, formatDisplayTime } from "src/utils/dateTime";
import { Box, HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Page } from "@ui/page/Page";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";
import { useEffect, useMemo, useRef, useState } from "react";
import { FormParser, TFormButton } from "../../FormParser";
import { client_registration_form_step_1_decorator } from "./steps/step_1";
import { mergeObject } from "src/utils/tools";
import { IRoadmapStep, Roadmap } from "src/view/conponents/roadmap/Roadmap";
import { client_registration_form_step_5_decorator } from "./steps/step_5";
import { client_registration_form_step_6_decorator } from "./steps/step_6";
import { GD } from "src/GD";
import { IconVisa } from "@ui/icons/IconVisa";
import { IconMastercard } from "@ui/icons/IconMastercard";
import { Checkbox } from "@ui/checkbox/Checkbox";
import Panel from "@ui/panel/Panel";
import { Link } from "@ui/link/Link";
import { clientInfoFormDecorator } from "../clientPage/subpages/clinent_info_mock";
import { Error } from "@ui/error/Error";
import { Spinner } from "@ui/spinner/Spinner";
import { IconAttention, IconPerson, IconTitle } from "./Icons";
import { client_registration_form_step_2_decorator } from "./steps/step_2";
import { client_registration_form_director_decorator } from "./steps/step_3";
import { client_registration_form_beneficiary_decorator } from "./steps/step_4";
import { useRouter } from "src/services/Router";

const nextButtonStyle = {
	transition: "background-color 0.3s, color 0.3s",
	padding: "15px 50px",
	"&:hover": { color: "#ffffff", backgroundColor: "#0148b3" },
	backgroundColor: "#0066ff",
	color: "#FFFFFF",
	fontSize: "14px",
	fontWeight: "600",
};

interface IStepViewProps {
	onStepSuccess: () => void;
	onBack?: (val: number) => void;
	clientID: number;
	stepIndex: number;
}

export const RegisterPage = ({}: {}) => {
	 useLocale();
	const router = useRouter();
	const clientID = router.currentParams.rid;

	const [clientId, setClientId] = useState<number>(clientID ? parseInt(clientID) : 0);

	const [state, setState] = useState<number>(-1);
	const [clientStatus, setClientStatus] = useState<
		"created" | "submitted" | "aml_review" | "rejected" | "board_review" | "active" | "blocked" | "deleted" | undefined
	>();

	useEffect(() => {
		if (clientId === -1 || clientId === 0) {
			setClientStatus("created");
		} else {
			!clientStatus && fetchClientStatus();
		}
	}, [clientId]);

	const fetchClientStatus = async () => {
		const req = await GD.REQ_API.request({
			method: "clients/get",
			data: {
				id: clientId,
			},
		});
		if (req.data) {
			setClientStatus(req.data.status);
		} else {
			//!TODO: handle error;
		}
	};

	const [showRoadmap, setShowRoadmap] = useState<boolean>(false);

	const [steps, setSteps] = useState<IRoadmapStep[]>([
		{ state: 0, status: "incomplete", name: msg("generalCompanyInformation") },
		{ state: 1, status: "incomplete", name: msg("companyWebsites") },
		{ state: 2, status: "incomplete", name: msg("authorisedRepresentative") },
		{ state: 3, status: "incomplete", name: msg("directors") },
		{ state: 4, status: "incomplete", name: msg("beneficialOwners") },
		{ state: 5, status: "incomplete", name: msg("payoutAccountDetails") },
		{ state: 6, status: "incomplete", name: msg("documentUploads") },
		{ state: 7, status: "incomplete", name: msg("submit_155f816c") },
	]);

	const onStepBack = (s: number) => {
		setState(s - 1);
	};

	const stateView = useMemo(() => {
		const views = [
			<Step_General stepIndex={0} onStepSuccess={() => onStepFinish(0)} clientID={clientId} />,
			<Step_Websites stepIndex={1} onStepSuccess={() => onStepFinish(1)} onBack={onStepBack} clientID={clientId} />,
			<Step_AuthorizedRepresentative stepIndex={2} onStepSuccess={() => onStepFinish(2)} onBack={onStepBack} clientID={clientId} />,
			<Step_Directors stepIndex={3} onStepSuccess={() => onStepFinish(3)} onBack={onStepBack} clientID={clientId} />,
			<Step_BeneficialOwners stepIndex={4} onStepSuccess={() => onStepFinish(4)} onBack={onStepBack} clientID={clientId} />,
			<Step_PayoutAccountDetails stepIndex={5} onStepSuccess={() => onStepFinish(5)} onBack={onStepBack} clientID={clientId} />,
			<Step_DocumentUploads stepIndex={6} onStepSuccess={() => onStepFinish(6)} onBack={onStepBack} clientID={clientId} />,
			<Step_ReviewAndConsents stepIndex={7} onStepSuccess={() => onStepFinish(7)} onBack={onStepBack} clientID={clientId} />,
		];
		return views;
	}, [clientId]);

	const onStepFinish = (s: number) => {
		if (s === 9) {
			return;
		}
		let nextStep = s + 1;

		if (s > -1 && s < steps.length) {
			const currentStep = steps[s];
			if (currentStep) {
				currentStep.status = "completed";
			}

			let isAllStepsCompleted = true;
			for (let index = 0; index < 7; index++) {
				if (steps[index].status !== "completed") {
					isAllStepsCompleted = false;
				}
			}
			if (isAllStepsCompleted && steps[7].status === "pending") {
				steps[7].status = "incomplete";
			}

			if (isAllStepsCompleted && s !== 7) {
				nextStep = 7;
			}

			if (s < 7) {
				if (!isAllStepsCompleted) {
					if (steps[nextStep].status === "completed" || steps[nextStep].status === "pending") {
						nextStep = steps.findIndex(step => step.status !== "completed" && step.status !== "pending");
					}
				}
			}

			setSteps([...steps]);
		}

		setState(nextStep);
	};

	const getState = (val: number) => {
		if (val < 0) {
			return (
				<WelcomeView
					onStart={(clientID?: number) => {
						if (clientID) {
							setClientId(clientID);
						}
						setShowRoadmap(true);
						setState(0);
					}}
					clientStatus={clientStatus}
					clientID={clientId}
				/>
			);
		} else if (val === 8) {
			return <Step_9 stepIndex={8} onStepSuccess={() => onStepFinish(-1)} clientID={clientId} />;
		} else {
			return stateView[val];
		}
	};

	const leftPanelWidth = "445px";

	//!TODO: color themes;
	return (
		<Page sx={{ padding: "0px", overflow: "hidden" }}>
			<HBox sx={{ display: "flex", height: "100%" }}>
				<Box
					sx={{
						height: "100%",
						width: showRoadmap ? leftPanelWidth : "0px",
						transition: "width 0.3s ease",
						backgroundColor: "#ffffff",
						overflow: "hidden",
						flexShrink: 0,
					}}>
					<Box sx={{ height: "100%", width: leftPanelWidth, backgroundColor: "#ffffff", padding: "20px", overflowY: "auto" }}>
						<Roadmap
							steps={steps}
							currentStepIndex={state}
							selectState={val => {
								if (clientId === -1 || clientId === 0) {
									//Client ID is not set. Cannot navigate to steps;
									return;
								}
								state < 8 && setState(val);
							}}
						/>
					</Box>
				</Box>
				{getState(state)}
			</HBox>
		</Page>
	);
};

const backButtonProps = (onBack: (val: number) => void, val: number): TFormButton => ({
	title: msg("back_639807a2"),
	variant: "secondary",
	sx: {
		transition: "background-color 0.3s, color 0.3s",
		padding: "15px 50px",
		// "&:hover": { color: "#ffffff", backgroundColor: "#0148b3" },
		// backgroundColor: "#0066ff",
		// color: "#FFFFFF",
		fontSize: "14px",
		fontWeight: "600",
	},
	onClick: () => onBack(val),
});

export const StepPreloader = ({}: {}) => {
	useLocale();
	//const theme = useTheme() as ITheme;
	const [showSpinner, setShowSpinner] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setShowSpinner(true);
		}, 700);

		return () => clearTimeout(timer);
	}, []);

	//!TODO: back color overlay;
	return (
		<VBox
			gap="30px"
			sx={{
				position: "absolute",
				top: 0,
				left: 0,
				alignItems: "center",
				justifyContent: "center",
				height: "100%",
				width: "100%",
				backgroundColor: "#f8fafc",
				zIndex: 10,
			}}>
			{showSpinner && <Spinner />}
		</VBox>
	);
};

export const FormOutline = ({ children }: { children: React.ReactNode }) => {
	useLocale();
	return <Box sx={{ minWidth: "500px", backgroundColor: "#f0f9ff", borderRadius: "12px", padding: "32px", border: "2px solid #0ea5e9" }}>{children}</Box>;
};

export const Step_General = ({ onStepSuccess, clientID }: IStepViewProps) => {
	useLocale();
	const [busySubmit, setBusySubmit] = useState(false);
	const [busyLoad, setBusyLoad] = useState(true);
	const contentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (busyLoad || busySubmit) {
			(contentRef.current as HTMLElement)?.scrollTo(0, 0);
		}
	}, [busyLoad, busySubmit]);

	return (
		<Box ref={contentRef} sx={{ overflowY: busyLoad || busySubmit ? "hidden" : "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					padding: "10px",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					opacity: busyLoad ? 0 : 1,
					transitionDelay: "300ms",
					transition: "opacity 0.3s ease-in-out",
				}}>
				<Spacer size="30px" />

				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#575761" }}>{msg("generalCompanyInformation")}</Typo>

				<Spacer size="10px" />

				<FormOutline>
					<FormParser
						key="step_1_form"
						onSubmit={async (data: any) => {
							if (data === null) {
								return;
							}
							let requestData = data;
							if (data && data.data && data.data.model) {
								const dataCopy = JSON.parse(JSON.stringify(data));
								dataCopy.data = dataCopy.data.model;
								requestData = dataCopy;
							}
							setBusySubmit(true);
							const response = await GD.REQ_API.request({
								method: "clients/form/set",
								data: requestData,
							});
							if (response.error) {
								setBusySubmit(false);
								return response;
							}
							let res = response.data;
							if (response && response.data && response.data.data) {
								res = { model: JSON.parse(JSON.stringify(response.data.data)) };
								mergeObject(res, client_registration_form_step_1_decorator);
							}
							setBusySubmit(false);
							onStepSuccess();
							return response;
						}}
						secondaryButton={null}
						primaryButton={{
							title: msg("continue"),
							variant: "primary",
							sx: nextButtonStyle,
						}}
						//  primaryButton={nextButtonProps(onStepSuccess, client_registration_form_step_1_decorator, setBusySubmit, clientID)}
						onRequest={async () => {
							setBusyLoad(true);

							const response = await GD.REQ_API.request({
								method: "clients/form/get",
								data: {
									target_id: clientID,
									target_type: "client",
									type: "client_info",
									subobject: "general_company_information",
								},
							});

							if (response.error) {
								setBusyLoad(false);
								return response;
							}
							if (response && response.data && response.data.data) {
								response.data.data = { model: JSON.parse(JSON.stringify(response.data.data)) };
								mergeObject(response.data.data, client_registration_form_step_1_decorator);
							}
							setBusyLoad(false);
							return response;
						}}
					/>
				</FormOutline>

				<Spacer size="30px" />
			</VBox>

			{(busyLoad || busySubmit) && <StepPreloader />}
		</Box>
	);
};

export const Step_PayoutAccountDetails = ({ onStepSuccess, onBack, stepIndex, clientID }: IStepViewProps) => {
	useLocale();
	const [busySubmit, setBusySubmit] = useState(false);
	const [busyLoad, setBusyLoad] = useState(true);
	const contentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (busyLoad || busySubmit) {
			(contentRef.current as HTMLElement)?.scrollTo(0, 0);
		}
	}, [busyLoad, busySubmit]);

	return (
		<Box ref={contentRef} sx={{ overflowY: busyLoad || busySubmit ? "hidden" : "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					padding: "10px",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					opacity: busyLoad ? 0 : 1,
					transition: "opacity 0.3s ease-in-out",
				}}>
				<Spacer size="30px" />

				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#575761" }}>{msg("payoutAccountDetails")}</Typo>

				<Typo variant="text" sx={{ color: "#475569", maxWidth: "600px", textAlign: "center", marginBottom: "16px" }}>{msg("pleaseProvideTheBankAccountDetailsToWhichPayoutsWillBeSentTh_c11c1445")}</Typo>

				<Spacer size="10px" />

				<FormOutline>
					<FormParser
						key="step_5_form"
						onSubmit={async (data: any) => {
							let requestData = data;
							if (data && data.data && data.data.model) {
								const dataCopy = JSON.parse(JSON.stringify(data));
								dataCopy.data = dataCopy.data.model;
								requestData = dataCopy;
							}
							setBusySubmit(true);

							const response = await GD.REQ_API.request({
								method: "clients/form/set",
								data: requestData,
							});
							if (response.error) {
								setBusySubmit(false);
								return response;
							}
							let res = response.data;
							if (response && response.data && response.data.data) {
								res = { model: JSON.parse(JSON.stringify(response.data.data)) };
								mergeObject(res, client_registration_form_step_5_decorator);
							}
							setBusySubmit(false);
							onStepSuccess();
							return response;
						}}
						secondaryButton={onBack && backButtonProps(onBack, stepIndex)}
						primaryButton={{
							title: msg("continue"),
							variant: "primary",
							sx: nextButtonStyle,
						}}
						onRequest={async () => {
							setBusyLoad(true);
							const response = await GD.REQ_API.request({
								method: "clients/form/get",
								data: {
									target_id: clientID,
									target_type: "client",
									type: "client_info",
									subobject: "payout_account_details",
								},
							});
							if (response.error) {
								setBusyLoad(false);
								return response;
							}
							if (response && response.data && response.data.data) {
								response.data.data = { model: JSON.parse(JSON.stringify(response.data.data)) };
								mergeObject(response.data.data, client_registration_form_step_5_decorator);
							}
							setBusyLoad(false);
							return response;
						}}
					/>
				</FormOutline>

				<Spacer size="30px" />
			</VBox>

			{(busyLoad || busySubmit) && <StepPreloader />}
		</Box>
	);
};

export const Step_DocumentUploads = ({ onStepSuccess, onBack, stepIndex, clientID }: IStepViewProps) => {
	useLocale();
	const [busySubmit, setBusySubmit] = useState(false);
	const [busyLoad, setBusyLoad] = useState(true);
	const contentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (busyLoad || busySubmit) {
			(contentRef.current as HTMLElement)?.scrollTo(0, 0);
		}
	}, [busyLoad, busySubmit]);

	return (
		<Box ref={contentRef} sx={{ overflowY: busyLoad || busySubmit ? "hidden" : "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					padding: "10px",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					opacity: busyLoad ? 0 : 1,
					transition: "opacity 0.3s ease-in-out",
				}}>
				<Spacer size="30px" />

				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#575761" }}>{msg("documentUploads")}</Typo>

				<Typo variant="text" sx={{ color: "#475569", maxWidth: "600px", textAlign: "center", marginBottom: "16px" }}>{msg("pleaseUploadTheRequiredDocumentsBelowAllFilesMustBeClearVali_f6a08afe")}</Typo>

				<Spacer size="10px" />

				<FormOutline>
					<FormParser
						key="step_6_form"
						onSubmit={async (data: any) => {
							let requestData = data;
							if (data && data.data && data.data.model) {
								const dataCopy = JSON.parse(JSON.stringify(data));
								dataCopy.data = dataCopy.data.model;
								requestData = dataCopy;
							}
							setBusySubmit(true);

							const response = await GD.REQ_API.request({
								method: "clients/form/set",
								data: requestData,
							});
							if (response.error) {
								setBusySubmit(false);
								return response;
							}
							let res = response.data;
							if (response && response.data && response.data.data) {
								res = { model: JSON.parse(JSON.stringify(response.data.data)) };
								mergeObject(res, client_registration_form_step_6_decorator);
							}
							setBusySubmit(false);
							onStepSuccess();
							return response;
						}}
						secondaryButton={onBack && backButtonProps(onBack, stepIndex)}
						primaryButton={{
							title: msg("continue"),
							variant: "primary",
							sx: nextButtonStyle,
						}}
						onRequest={async () => {
							setBusyLoad(true);

							const response = await GD.REQ_API.request({
								method: "clients/form/get",
								data: {
									target_id: clientID,
									target_type: "client",
									type: "client_info",
									subobject: "document_uploads",
								},
							});
							if (response.error) {
								setBusyLoad(false);
								return response;
							}
							if (response && response.data && response.data.data) {
								response.data.data = { model: JSON.parse(JSON.stringify(response.data.data)) };
								mergeObject(response.data.data, client_registration_form_step_6_decorator);
							}
							setBusyLoad(false);
							return response;
						}}
					/>
				</FormOutline>

				<Spacer size="30px" />
			</VBox>

			{(busyLoad || busySubmit) && <StepPreloader />}
		</Box>
	);
};

// export const Step_7 = ({ onStepSuccess, clientID }: IStepViewProps) => {
// 	//!TODO:;
// 	const [_busy, setBusy] = useState(false);

// 	return (
// 		<Box sx={{ overflowY: "auto", height: "100%", width: "100%" }}>
// 			<VBox
// 				sx={{
// 					padding: "10px",
// 					alignItems: "center",
// 					justifyContent: "center",
// 					display: "flex",
// 					overflowY: "auto",
// 				}}>
// 				<Spacer size="30px" />

// 				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#575761" }}>
// 					Consents and warranties
// 				</Typo>

// 				<Typo variant="text" sx={{ color: "#475569", maxWidth: "600px", textAlign: "center", marginBottom: "16px" }}>
// 					//!TODO: description text here
// 				</Typo>

// 				<Spacer size="10px" />

// 				<FormOutline>
// 					<FormParser
// 						key="step_7_form"
// 						onSubmit={async (_data: any) => {
// 							const res = JSON.parse(JSON.stringify(client_registration_form_step_7));
// 							mergeObject(res, client_registration_form_step_7_decorator);
// 							return res;
// 						}}
// 						secondaryButton={null}
// 						//!TODO: buttons to component
// 						primaryButton={nextButtonProps(onNext, client_registration_form_step_7_decorator, setBusy, clientID)}
// 						onRequest={async () => {
// 							const res = JSON.parse(JSON.stringify(client_registration_form_step_7));
// 							mergeObject(res, client_registration_form_step_7_decorator);

// 							return res;
// 						}}
// 					/>
// 				</Box>

// 				<Spacer size="30px" />
// 			</VBox>
// 		</Box>
// 	);
// };

export const Step_AuthorizedRepresentative = ({ onStepSuccess, onBack, clientID, stepIndex }: IStepViewProps) => {
	useLocale();
	const [busySubmit, setBusySubmit] = useState(false);
	const [busyLoad, setBusyLoad] = useState(true);
	const contentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (busyLoad || busySubmit) {
			(contentRef.current as HTMLElement)?.scrollTo(0, 0);
		}
	}, [busyLoad, busySubmit]);

	return (
		<Box ref={contentRef} sx={{ overflowY: busyLoad || busySubmit ? "hidden" : "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					padding: "10px",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					opacity: busyLoad ? 0 : 1,
					transition: "opacity 0.3s ease-in-out",
				}}>
				<Spacer size="30px" />

				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#575761" }}>{msg("authorisedRepresentative")}</Typo>

				<Spacer size="10px" />

				<FormOutline>
					<FormParser
						key="step_2_form"
						onSubmit={async (data: any) => {
							let requestData = data;
							if (data && data.data && data.data.model) {
								const dataCopy = JSON.parse(JSON.stringify(data));
								dataCopy.data = dataCopy.data.model;
								requestData = dataCopy;
							}
							setBusySubmit(true);

							const response = await GD.REQ_API.request({
								method: "clients/form/set",
								data: requestData,
							});
							if (response.error) {
								setBusySubmit(false);
								return response;
							}
							let res = response.data;
							if (response && response.data && response.data.data) {
								res = { model: JSON.parse(JSON.stringify(response.data.data)) };
								mergeObject(res, client_registration_form_step_2_decorator);
							}
							setBusySubmit(false);
							onStepSuccess();
							return response;
						}}
						secondaryButton={onBack && backButtonProps(onBack, stepIndex)}
						primaryButton={{
							title: msg("continue"),
							variant: "primary",
							sx: nextButtonStyle,
						}}
						onRequest={async () => {
							setBusyLoad(true);
							const response = await GD.REQ_API.request({
								method: "clients/form/get",
								data: {
									target_id: clientID,
									target_type: "client",
									type: "client_info",
									subobject: "authorised_representative",
								},
							});
							if (response && response.data && response.data.data) {
								response.data.data = { model: JSON.parse(JSON.stringify(response.data.data)) };
								mergeObject(response.data.data, client_registration_form_step_2_decorator);
							}
							setBusyLoad(false);
							return response;
						}}
					/>
				</FormOutline>

				<Spacer size="30px" />
			</VBox>

			{(busyLoad || busySubmit) && <StepPreloader />}
		</Box>
	);
};

export const Step_Directors = ({ onStepSuccess, onBack, stepIndex, clientID }: IStepViewProps) => {
	useLocale();
	const [directors, setDirectors] = useState<IClientDirector[]>([]);
	const [showAddForm, setShowAddForm] = useState<{ id: number } | null>(null);
	const [busySubmit, setBusySubmit] = useState(false);
	const [busyLoad, setBusyLoad] = useState(true);
	const contentRef = useRef<HTMLDivElement>(null);
	const [error, setError] = useState<IError | null>(null);

	useEffect(() => {
		if (busyLoad || busySubmit) {
			(contentRef.current as HTMLElement)?.scrollTo(0, 0);
		}
	}, [busyLoad, busySubmit]);

	const fetchDirectors = async () => {
		setError(null);
		setBusyLoad(true);

		const response = await GD.REQ_API.request({
			method: "clients/person/list",
			data: {
				client_id: clientID,
				type: "director",
			},
		});

		if (response.error) {
			setBusyLoad(false);
			setError(response.error);
			return;
		}

		if (response && response.data && Array.isArray(response.data)) {
			setDirectors(response.data.filter((w: any) => w.status !== "deleted" && w.id > 0 && w.type === "director"));
		}

		setBusyLoad(false);
	};

	useEffect(() => {
		fetchDirectors();
	}, [clientID]);

	const onNext = () => {
		onStepSuccess();
	};

	const handleEditComplete = (updated: boolean) => {
		setShowAddForm(null);
		updated && fetchDirectors();
	};

	const handleRemoveDirector = async (director: IClientDirector) => {
		if (!busyLoad && !busySubmit) {
			setBusySubmit(true);
			const response = await GD.REQ_API.request({
				method: "clients/person/status/change",
				data: {
					person_id: director.id,
					client_id: clientID,
					status: "deleted",
					reason: "Removed by user during registration process",
				},
			});

			if (response.error) {
				setError(response.error);
			}
			setBusySubmit(false);
			fetchDirectors();
		}
	};

	return (
		<Box ref={contentRef} sx={{ overflowY: busyLoad || busySubmit ? "hidden" : "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					padding: "10px",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					opacity: busyLoad ? 0 : 1,
					transition: "opacity 0.3s ease-in-out",
				}}>
				<Spacer size="20px" />

				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#1a1a2e" }}>{msg("directors")}</Typo>

				{error && (
					<>
						<Spacer size="10px" />
						<Error error={error} />
					</>
				)}

				<Spacer size="10px" />

				{directors.length === 0 && !showAddForm ? (
					<DirectorsEmptyBlock onAddClick={() => setShowAddForm({ id: 0 })} onBack={() => onBack && onBack(stepIndex)} />
				) : (
					<VBox sx={{ width: "100%", maxWidth: "700px", gap: "12px" }}>
						{!showAddForm &&
							directors.map((director, index) => (
								<DirectorCard
									key={index}
									director={director}
									onRemove={() => handleRemoveDirector(director)}
									onEdit={() => setShowAddForm({ id: director.id })}
								/>
							))}

						{showAddForm ? (
							<DirectorAddForm
								onComplete={handleEditComplete}
								directorID={showAddForm.id}
								clientID={clientID}
								label={showAddForm.id > 0 ? msg("editDirector") : msg("addNewDirector")}
								buttonTitle={showAddForm.id > 0 ? msg("saveChanges_35322b5b") : msg("addDirector")}
							/>
						) : (
							<>
								<Spacer size="10px" />
								<Button
									variant="secondary"
									title={msg("addAnotherDirector")}
									onClick={() => setShowAddForm({ id: 0 })}
									sx={{
										padding: "12px 24px",
										alignSelf: "center",
									}}
								/>
							</>
						)}

						{directors.length > 0 && !showAddForm && (
							<>
								<Spacer size="20px" />
								<StepButtons onStepSuccess={onNext} onBack={() => onBack && onBack(stepIndex)} />
							</>
						)}
					</VBox>
				)}

				<Spacer size="20px" />
			</VBox>

			{(busyLoad || busySubmit) && <StepPreloader />}
		</Box>
	);
};

const StepButtons = ({ onStepSuccess, onBack }: { onStepSuccess: () => void; onBack?: () => void }) => {
	useLocale();
	return (
		<HBox sx={{ width: "100%", justifyContent: "space-between", gap: "16px" }}>
			{onBack && <BackButton onClick={onBack} />}
			{onStepSuccess && <NextButton onClick={onStepSuccess} title={msg("continue")} />}
		</HBox>
	);
};

const NextButton = ({ onClick, title }: { onClick: () => void; title: string }) => {
	useLocale();
	return (
		<Button
			variant="primary"
			title={title}
			onClick={onClick}
			sx={{
				transition: "background-color 0.3s, color 0.3s",
				padding: "15px 50px",
				"&:hover": { color: "#ffffff", backgroundColor: "#0148b3" },
				backgroundColor: "#0066ff",
				color: "#FFFFFF",
				fontSize: "14px",
				fontWeight: "600",
				alignSelf: "center",
			}}
		/>
	);
};

const BackButton = ({ onClick }: { onClick: () => void }) => {
	useLocale();
	return (
		<Button
			variant="secondary"
			title={msg("back_639807a2")}
			onClick={onClick}
			sx={{
				transition: "background-color 0.3s, color 0.3s",
				padding: "15px 50px",
				// "&:hover": { color: "#ffffff", backgroundColor: "#0148b3" },
				// backgroundColor: "#0066ff",
				// color: "#FFFFFF",
				fontSize: "14px",
				fontWeight: "600",
				alignSelf: "center",
			}}
		/>
	);
};

const DirectorsEmptyBlock = ({ onAddClick, onBack }: { onAddClick: () => void; onBack?: () => void }) => {
	useLocale();
	return (
		<VBox
			sx={{
				alignItems: "center",
				justifyContent: "center",
				padding: "60px 40px",
				backgroundColor: "#f8fafc",
				borderRadius: "16px",
				border: "2px dashed #cbd5e1",
				maxWidth: "600px",
				width: "100%",
			}}>
			<Box
				sx={{
					width: "80px",
					height: "80px",
					borderRadius: "50%",
					backgroundColor: "#e0f2fe",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					marginBottom: "24px",
				}}>
				<IconPerson color="#0369a1" />
			</Box>

			<Typo variant="headMedium" bold sx={{ color: "#1e293b", marginBottom: "12px", textAlign: "center" }}>{msg("noDirectorsAddedYet")}</Typo>

			<Typo variant="text" sx={{ color: "#64748b", lineHeight: "1.6", textAlign: "center", marginBottom: "32px", maxWidth: "400px" }}>{msg("pleaseAddAtLeastOneDirectorIfTheCompanyHasMultipleDirectorsP_183873b2")}</Typo>

			<Box
				sx={{
					backgroundColor: "#fffbeb",
					border: "1px solid #fcd34d",
					borderRadius: "12px",
					padding: "16px 24px",
					marginBottom: "32px",
					maxWidth: "450px",
				}}>
				<HBox sx={{ alignItems: "center", gap: "12px" }}>
					<IconAttention color="#b45309" />
					<Typo variant="text" sx={{ color: "#92400e" }}>{msg("atLeastOneDirectorIsRequiredToCompleteTheRegistrationProcess")}</Typo>
				</HBox>
			</Box>

			{/* //!TODO: gap value; */}
			<HBox sx={{}} gap="16px">
				{onBack && <BackButton onClick={onBack} />}
				<NextButton onClick={onAddClick} title={msg("addDirector_c4bf7416")} />
			</HBox>
		</VBox>
	);
};

const DirectorCard = ({ director, onRemove, onEdit }: { director: IClientDirector; onRemove: () => void; onEdit: () => void }) => {
	useLocale();
	return (
		<HBox
			sx={{
				backgroundColor: "#ffffff",
				borderRadius: "12px",
				padding: "20px 24px",
				boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
				border: "1px solid #e2e8f0",
				alignItems: "center",
				gap: "20px",
			}}>
			<Box
				sx={{
					width: "50px",
					height: "50px",
					borderRadius: "50%",
					backgroundColor: "#e0f2fe",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexShrink: 0,
				}}>
				<Typo variant="medium" bold sx={{ color: "#0369a1" }}>
					{director.name?.charAt(0) ?? ""}
				</Typo>
			</Box>

			<VBox sx={{ flexGrow: 1 }}>
				<Typo variant="medium" bold sx={{ color: "#1e293b" }}>
					{director.name ?? ""}
				</Typo>
				<Typo variant="small" sx={{ color: "#64748b" }}>
					{director.dob ?? ""}
				</Typo>
				{director.data && (
					<HBox sx={{ gap: "16px", marginTop: "4px" }}>
						<Typo variant="small" sx={{ color: "#94a3b8" }}>
							{director.data.citizenship ?? ""}
						</Typo>
						<Typo variant="small" sx={{ color: "#94a3b8" }}>
							{director.data.residential_address ?? ""}
						</Typo>
					</HBox>
				)}
			</VBox>

			<Button
				variant="secondary"
				title={msg("edit")}
				onClick={onEdit}
				sx={{
					padding: "8px 16px",
					color: "#2657dc",
					borderColor: "#cae7fe",
					"&:hover": {
						backgroundColor: "#f2fafe",
						borderColor: "#2657dc",
					},
				}}
			/>

			<Button
				variant="secondary"
				title={msg("remove")}
				onClick={onRemove}
				sx={{
					padding: "8px 16px",
					color: "#dc2626",
					borderColor: "#fecaca",
					"&:hover": {
						backgroundColor: "#fef2f2",
						borderColor: "#dc2626",
					},
				}}
			/>
		</HBox>
	);
};

const DirectorAddForm = ({
	clientID,
	directorID,
	onComplete,
	label,
	buttonTitle,
}: {
	clientID?: number;
	directorID?: number;
	onComplete: (updated: boolean) => void;
	label: string;
	buttonTitle: string;
}) => {
	useLocale();
	return (
		<VBox
			sx={{
				backgroundColor: "#f0f9ff",
				borderRadius: "12px",
				padding: "24px",
				border: "2px solid #0ea5e9",
			}}>
			<Typo variant="medium" bold sx={{ color: "#0369a1", marginBottom: "20px" }}>
				{label}
			</Typo>

			<FormParser
				key="step_3_form"
				onSubmit={async (data: any) => {
					//	setBusy(true);
					const response = await GD.REQ_API.request({
						method: "clients/person/add",
						data: data,
					});
					if (response && response.data && response.data.data) {
						onComplete(true);
					}
					//	setBusy(false);
					return response;
				}}
				//!TODO: all buttons font size;
				secondaryButton={{
					variant: "secondary",
					title: msg("cancel"),
					onClick: () => onComplete(false),
					sx: {
						fontSize: "16px",
						padding: "10px 24px",
					},
				}}
				primaryButton={{
					variant: "primary",
					title: buttonTitle,

					sx: {
						padding: "10px 24px",
						backgroundColor: "#0066ff",
						color: "#FFFFFF",
						fontSize: "16px",
						"&:hover": {
							backgroundColor: "#0052cc",
						},
					},
				}}
				onRequest={async () => {
					//	setBusy(true);
					const response = await GD.REQ_API.request({
						method: "clients/person/get",
						data: {
							client_id: clientID,
							id: directorID,
							type: "director",
						},
					});
					if (response && response.data && response.data.data) {
						mergeObject(response.data.data, JSON.parse(JSON.stringify(client_registration_form_director_decorator)));
					}

					//		setBusy(false);
					return response;
				}}
			/>
		</VBox>
	);
};

export const Step_BeneficialOwners = ({ onStepSuccess, onBack, stepIndex, clientID }: IStepViewProps) => {
	useLocale();
	const [beneficiaries, setBeneficiaries] = useState<IClientBeneficiary[]>([]);
	const [showAddForm, setShowAddForm] = useState<{ id: number } | null>(null);
	const [busySubmit, setBusySubmit] = useState(false);
	const [busyLoad, setBusyLoad] = useState(true);
	const contentRef = useRef<HTMLDivElement>(null);
	const [error, setError] = useState<IError | null>(null);

	useEffect(() => {
		if (busyLoad || busySubmit) {
			(contentRef.current as HTMLElement)?.scrollTo(0, 0);
		}
	}, [busyLoad, busySubmit]);

	const fetchBeneficiaries = async () => {
		setError(null);
		setBusyLoad(true);

		const response = await GD.REQ_API.request({
			method: "clients/person/list",
			data: {
				client_id: clientID,
				type: "beneficial_owner",
			},
		});

		if (response.error) {
			setBusyLoad(false);
			setError(response.error);
			return;
		}

		if (response && response.data && Array.isArray(response.data)) {
			setBeneficiaries(response.data.filter((w: any) => w.status !== "deleted" && w.id > 0 && w.type === "beneficial_owner"));
		}

		setBusyLoad(false);
	};

	useEffect(() => {
		fetchBeneficiaries();
	}, [clientID]);

	const onNext = () => {
		onStepSuccess();
	};

	const handleEditComplete = (updated: boolean) => {
		setShowAddForm(null);
		updated && fetchBeneficiaries();
	};

	const handleRemoveBeneficiary = async (beneficiary: IClientBeneficiary) => {
		if (!busyLoad && !busySubmit) {
			setBusySubmit(true);
			const response = await GD.REQ_API.request({
				method: "clients/person/status/change",
				data: {
					person_id: beneficiary.id,
					client_id: clientID,
					status: "deleted",
					reason: "Removed by user during registration process",
				},
			});

			if (response.error) {
				setError(response.error);
			}
			setBusySubmit(false);
			fetchBeneficiaries();
		}
	};

	return (
		<Box ref={contentRef} sx={{ overflowY: busyLoad || busySubmit ? "hidden" : "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					padding: "10px",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					opacity: busyLoad ? 0 : 1,
					transition: "opacity 0.3s ease-in-out",
				}}>
				<Spacer size="20px" />

				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#1a1a2e" }}>{msg("beneficialOwners")}</Typo>

				{error && (
					<>
						<Spacer size="10px" />
						<Error error={error} />
					</>
				)}

				<Spacer size="10px" />

				{beneficiaries.length === 0 && !showAddForm ? (
					<BeneficiaryEmptyBlock onAddClick={() => setShowAddForm({ id: 0 })} onBack={() => onBack && onBack(stepIndex)} />
				) : (
					<VBox sx={{ width: "100%", maxWidth: "700px", gap: "12px" }}>
						{!showAddForm &&
							beneficiaries.map((beneficiary, index) => (
								<BeneficiaryCard
									key={index}
									beneficiary={beneficiary}
									onRemove={() => handleRemoveBeneficiary(beneficiary)}
									onEdit={() => setShowAddForm({ id: beneficiary.id })}
								/>
							))}

						{showAddForm ? (
							<BeneficiaryAddForm
								onComplete={handleEditComplete}
								beneficiaryID={showAddForm.id}
								clientID={clientID}
								label={showAddForm.id > 0 ? msg("editBeneficiary_26a0140e") : msg("addNewBeneficiary")}
								buttonTitle={showAddForm.id > 0 ? msg("saveChanges_35322b5b") : msg("addBeneficiary_eab44a54")}
							/>
						) : (
							<>
								<Spacer size="10px" />
								<Button
									variant="secondary"
									title={msg("addAnotherBeneficiary")}
									onClick={() => setShowAddForm({ id: 0 })}
									sx={{
										padding: "12px 24px",
										alignSelf: "center",
									}}
								/>
							</>
						)}

						{beneficiaries.length > 0 && !showAddForm && (
							<>
								<Spacer size="20px" />

								<StepButtons onStepSuccess={onNext} onBack={() => onBack && onBack(stepIndex)} />
							</>
						)}
					</VBox>
				)}

				<Spacer size="20px" />
			</VBox>

			{(busyLoad || busySubmit) && <StepPreloader />}
		</Box>
	);
};

const BeneficiaryEmptyBlock = ({ onAddClick, onBack }: { onAddClick: () => void; onBack?: () => void }) => {
	useLocale();
	return (
		<VBox
			sx={{
				alignItems: "center",
				justifyContent: "center",
				padding: "60px 40px",
				backgroundColor: "#f8fafc",
				borderRadius: "16px",
				border: "2px dashed #cbd5e1",
				maxWidth: "600px",
				width: "100%",
			}}>
			<Box
				sx={{
					width: "80px",
					height: "80px",
					borderRadius: "50%",
					backgroundColor: "#e0f2fe",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					marginBottom: "24px",
				}}>
				<IconPerson color="#0369a1" />
			</Box>

			<Typo variant="headMedium" bold sx={{ color: "#1e293b", marginBottom: "12px", textAlign: "center" }}>{msg("noBeneficiariesAddedYet")}</Typo>

			<Typo variant="text" sx={{ color: "#64748b", lineHeight: "1.6", textAlign: "center", marginBottom: "32px", maxWidth: "400px" }}>{msg("pleaseAddAtLeastOneBeneficiaryToProceedWithTheRegistrationBe_d5b6e4d2")}</Typo>

			<Box
				sx={{
					backgroundColor: "#fffbeb",
					border: "1px solid #fcd34d",
					borderRadius: "12px",
					padding: "16px 24px",
					marginBottom: "32px",
					maxWidth: "450px",
				}}>
				<HBox sx={{ alignItems: "center", gap: "12px" }}>
					<IconAttention color="#b45309" />
					<Typo variant="text" sx={{ color: "#92400e" }}>{msg("atLeastOneBeneficiaryIsRequiredToCompleteTheRegistrationProcess")}</Typo>
				</HBox>
			</Box>

			<HBox sx={{}} gap="16px">
				{onBack && <BackButton onClick={onBack} />}
				<NextButton onClick={onAddClick} title={msg("addBeneficiary_9a54387f")} />
			</HBox>
		</VBox>
	);
};

const BeneficiaryCard = ({ beneficiary, onRemove, onEdit }: { beneficiary: IClientBeneficiary; onRemove: () => void; onEdit: () => void }) => {
	useLocale();
	return (
		<HBox
			sx={{
				backgroundColor: "#ffffff",
				borderRadius: "12px",
				padding: "20px 24px",
				boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
				border: "1px solid #e2e8f0",
				alignItems: "center",
				gap: "20px",
			}}>
			<Box
				sx={{
					width: "50px",
					height: "50px",
					borderRadius: "50%",
					backgroundColor: "#e0f2fe",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					flexShrink: 0,
				}}>
				<Typo variant="medium" bold sx={{ color: "#0369a1" }}>
					{beneficiary.name?.charAt(0) ?? ""}
				</Typo>
			</Box>

			<VBox sx={{ flexGrow: 1 }}>
				<Typo variant="medium" bold sx={{ color: "#1e293b" }}>
					{beneficiary.name ?? ""}
				</Typo>
				<Typo variant="small" sx={{ color: "#64748b" }}>
					{beneficiary.dob ?? ""}
				</Typo>
				{beneficiary.data && (
					<HBox sx={{ gap: "16px", marginTop: "4px" }}>
						<Typo variant="small" sx={{ color: "#94a3b8" }}>
							{beneficiary.data.citizenship ?? ""}
						</Typo>
						<Typo variant="small" sx={{ color: "#94a3b8" }}>
							{beneficiary.data.residential_address ?? ""}
						</Typo>
					</HBox>
				)}
			</VBox>

			<Button
				variant="secondary"
				title={msg("edit")}
				onClick={onEdit}
				sx={{
					padding: "8px 16px",
					color: "#2657dc",
					borderColor: "#cae7fe",
					"&:hover": {
						backgroundColor: "#f2fafe",
						borderColor: "#2657dc",
					},
				}}
			/>

			<Button
				variant="secondary"
				title={msg("remove")}
				onClick={onRemove}
				sx={{
					padding: "8px 16px",
					color: "#dc2626",
					borderColor: "#fecaca",
					"&:hover": {
						backgroundColor: "#fef2f2",
						borderColor: "#dc2626",
					},
				}}
			/>
		</HBox>
	);
};

const BeneficiaryAddForm = ({
	clientID,
	beneficiaryID,
	onComplete,
	label,
	buttonTitle,
}: {
	clientID: number;
	beneficiaryID: number;
	onComplete: (updated: boolean) => void;
	label: string;
	buttonTitle: string;
}) => {
	useLocale();
	return (
		<VBox
			sx={{
				backgroundColor: "#f0f9ff",
				borderRadius: "12px",
				padding: "24px",
				border: "2px solid #0ea5e9",
			}}>
			<Typo variant="medium" bold sx={{ color: "#0369a1", marginBottom: "20px" }}>
				{label}
			</Typo>

			<FormParser
				key="step_3_form"
				onSubmit={async (data: any) => {
					//	setBusy(true);
					const response = await GD.REQ_API.request({
						method: "clients/person/add",
						data: data,
					});
					if (response && response.data && response.data.data) {
						onComplete(true);
					}
					//	setBusy(false);
					return response;
				}}
				//!TODO: all buttons font size;
				secondaryButton={{
					variant: "secondary",
					title: msg("cancel"),
					onClick: () => onComplete(false),
					sx: {
						fontSize: "16px",
						padding: "10px 24px",
					},
				}}
				primaryButton={{
					variant: "primary",
					title: buttonTitle,

					sx: {
						padding: "10px 24px",
						backgroundColor: "#0066ff",
						color: "#FFFFFF",
						fontSize: "16px",
						"&:hover": {
							backgroundColor: "#0052cc",
						},
					},
				}}
				onRequest={async () => {
					//	setBusy(true);
					const response = await GD.REQ_API.request({
						method: "clients/person/get",
						data: {
							client_id: clientID,
							id: beneficiaryID,
							type: "beneficial_owner",
						},
					});
					if (response && response.data && response.data.data) {
						mergeObject(response.data.data, JSON.parse(JSON.stringify(client_registration_form_beneficiary_decorator)));
					}

					//		setBusy(false);
					return response;
				}}
			/>
		</VBox>
	);
};

const EventsTimeline = ({ events }: { events: IEvent[] }) => {
	useLocale();
	const formatDate = (dateString: string) => formatDisplayDate(dateString, { locale: "en-GB", format: { day: "2-digit", month: "short", year: "numeric" }, withZone: false });

	const formatTime = (dateString: string) => formatDisplayTime(dateString, { locale: "en-GB", format: { hour: "2-digit", minute: "2-digit" } });

	// {"new_status":"in_progress","old_status":"submitted","reason":"reason 123"}'

	const getEventDescription = (event: IEvent) => {
		try {
			const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;

			if (event.action === "client_status_change") {
				const statusLabels: Record<string, string> = {
					created: "Created",
					deleted: "Deleted",
					active: "Activated",
					submitted: "Submitted",
					aml_review: msg("amlReview"),
					rejected: "Rejected",
					in_progress: msg("inProgress"),
				};
				const oldStatus = statusLabels[data.old_status] || data.old_status;
				const newStatus = statusLabels[data.new_status] || data.new_status;
				return msg("templateStatusChangedFromTo_22d904c2", { v0: oldStatus, v1: newStatus });
			}

			return event.action.replace(/_/g, " ");
		} catch {
			return event.action.replace(/_/g, " ");
		}
	};

	const getEventReason = (event: IEvent) => {
		try {
			const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
			return "Reason: " + data.reason;
		} catch {
			return "";
		}
	};

	const getEventIcon = (event: IEvent) => {
		try {
			const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;

			if (event.action === "client_status_change") {
				if (data.new_status === "deleted") {
					return { color: "#dc2626", bgColor: "#fef2f2" };
				}
				if (data.new_status === "approved" || data.new_status === "active") {
					return { color: "#16a34a", bgColor: "#f0fdf4" };
				}
				if (data.new_status === "rejected") {
					return { color: "#dc2626", bgColor: "#fef2f2" };
				}
			}
		} catch {}
		return { color: "#0369a1", bgColor: "#e0f2fe" };
	};

	return (
		<VBox
			sx={{
				marginTop: "40px",
				maxWidth: "600px",
				width: "100%",
				padding: "24px",
				backgroundColor: "#ffffff",
				borderRadius: "12px",
				boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
			}}>
			<Typo variant="medium" bold sx={{ color: "#1e293b", marginBottom: "24px" }}>{msg("recentActivity")}</Typo>

			<VBox sx={{ position: "relative" }}>
				{events.map((event, index) => {
					const iconStyle = getEventIcon(event);
					const isLast = index === events.length - 1;

					return (
						<HBox key={event.id} sx={{ position: "relative", paddingBottom: isLast ? "0" : "24px" }}>
							{/* Timeline line */}
							{!isLast && (
								<Box
									sx={{
										position: "absolute",
										left: "15px",
										top: "32px",
										width: "2px",
										height: "calc(100% - 8px)",
										backgroundColor: "#e2e8f0",
									}}
								/>
							)}

							{/* Timeline dot */}
							<Box
								sx={{
									width: "32px",
									height: "32px",
									borderRadius: "50%",
									backgroundColor: iconStyle.bgColor,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									flexShrink: 0,
									marginRight: "16px",
									border: `2px solid ${iconStyle.color}`,
								}}>
								<Box
									sx={{
										width: "8px",
										height: "8px",
										borderRadius: "50%",
										backgroundColor: iconStyle.color,
									}}
								/>
							</Box>

							{/* Event content */}
							<VBox sx={{ flex: 1, paddingTop: "4px" }}>
								<HBox sx={{ justifyContent: "space-between", alignItems: "flex-start", marginBottom: "4px" }}>
									<Typo variant="text" sx={{ color: "#1e293b", fontWeight: 500 }}>
										{getEventDescription(event)}
									</Typo>
								</HBox>
								<HBox sx={{ justifyContent: "space-between", alignItems: "flex-start", marginBottom: "4px" }}>
									<Typo variant="text" sx={{ color: "#1e293b", fontWeight: 500 }}>
										{getEventReason(event)}
									</Typo>
								</HBox>
								<HBox sx={{ gap: "8px", alignItems: "center" }}>
									<Typo variant="small" sx={{ color: "#94a3b8" }}>
										<DateTimeTooltip value={event.created_at}>{formatDate(event.created_at)}</DateTimeTooltip>
									</Typo>
									<Typo variant="small" sx={{ color: "#cbd5e1" }}>
										•
									</Typo>
									<Typo variant="small" sx={{ color: "#94a3b8" }}>
										<DateTimeTooltip value={event.created_at}>{formatTime(event.created_at)}</DateTimeTooltip>
									</Typo>
								</HBox>
							</VBox>
						</HBox>
					);
				})}
			</VBox>
		</VBox>
	);
};

const WelcomeView = ({ onStart, clientStatus, clientID }: { onStart: (clientID?: number) => void; clientStatus?: string; clientID: number }) => {
	useLocale();
	const [events, setEvents] = useState<IEvent[]>([]);

	useEffect(() => {
		if (clientStatus !== "created") {
			loadClientEvents();
		}
	}, [clientStatus]);

	const loadClientEvents = async () => {
		const events = await GD.REQ_CLIENT_EVENTS.request({ clientID: clientID });

		if (events && events.data) {
			setEvents(events.data.filter((e: IEvent) => e.action === "client_status_change"));
		}
	};

	const onNext = async () => {
		if (clientID) {
			onStart();
		} else {
			const response = await GD.REQ_API.request({
				method: "clients/form/get",
				data: {
					target_id: clientID,
					target_type: "client",
					type: "client_info",
					subobject: "general_company_information",
				},
			});
			if (response && response.data && response.data) {
				onStart(response.data.target_id);
			}

			// const newClient = await GD.REQ_API.request({
			// 	method: "clients/add",
			// 	data: {
			// 		id: 0,
			// 		project_id: (await GD.B_SELECTED_PROJECT.execute())?.id,
			// 	},
			// });
			// console.log("New client created:", newClient);

			// const response = await GD.REQ_API.request({
			// 	method: "clients/create",
			// 	data: {},
			// });

			// if (newClient && newClient.data && newClient.data.data) {
			// 	onStart(newClient.data.data);
			// }
			//onStart(0);
		}
	};

	if (!clientStatus) {
		return null;
	}

	return (
		<Box sx={{ overflowY: "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					padding: "40px",
					alignItems: "center",
					justifyContent: "center",
				}}>
				<VBox
					sx={{
						alignContent: "center",
						alignItems: "center",
						maxWidth: "600px",
						textAlign: "center",
						padding: "60px",
						backgroundColor: "#ffffff",
						borderRadius: "10px",
						boxShadow: "0 3px 6px rgba(0, 0, 0, 0.08)",
					}}>
					<Box
						sx={{
							width: "80px",
							height: "80px",
							borderRadius: "50%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}>
						<IconTitle color="#ff9100" />
					</Box>

					<Typo variant="head" bold sx={{ marginBottom: "16px", color: "#1a1a2e" }}>
						{clientStatus !== "created" ? msg("completeYourRegistration") : msg("welcomeToRegistration")}
					</Typo>

					<Spacer size="10px" />

					<Typo
						variant="text"
						sx={{
							color: "#64748b",
							lineHeight: "1.4",
						}}>
						{clientStatus !== "created"
							? msg("toStartUsingOurServicesPleaseCompleteYourRegistrationByProvi_18df7004")
							: msg("weReExcitedToHaveYouOnBoardCompleteTheRegistrationProcessToG_e8c58607")}
					</Typo>

					<Spacer size="60px" />

					<Button
						variant="primary"
						title={clientStatus !== "created" ? msg("completeRegistration") : msg("startRegistration")}
						onClick={onNext}
						sx={{
							padding: "16px 48px",
							fontSize: "16px",
							fontWeight: "600",
							borderRadius: "12px",
							boxShadow: "0 0px 0px rgba(0, 0, 0, 0.1)",
							transition: "transform 0.2s, box-shadow 0.2s, background-color 0.4s",
							"&:hover": {
								transform: "translateY(-0px)",
								backgroundColor: "#0066ff",
								boxShadow: "0 3px 10px rgba(0, 0, 0, 0.4)",
							},
						}}
					/>
				</VBox>

				{events.length > 0 && <EventsTimeline events={events} />}
			</VBox>
		</Box>
	);
};

// const Step_8 = ({ onNext }: IStepViewProps) => {
// 	return (
// 		<VBox
// 			sx={{
// 				padding: "40px",
// 				flex: 1,
// 				alignItems: "center",
// 				justifyContent: "center",
// 				display: "flex",
// 			}}>
// 			<VBox
// 				sx={{
// 					alignContent: "center",
// 					alignItems: "center",
// 					maxWidth: "600px",
// 					textAlign: "center",
// 					padding: "60px",
// 					backgroundColor: "#ffffff",
// 					borderRadius: "10px",
// 					boxShadow: "0 3px 6px rgba(0, 0, 0, 0.08)",
// 				}}>
// 				<Box
// 					sx={{
// 						width: "80px",
// 						height: "80px",
// 						borderRadius: "50%",
// 						display: "flex",
// 						alignItems: "center",
// 						justifyContent: "center",
// 					}}>
// 					<IconTitle color="#ff9100" />
// 				</Box>

// 				<Typo variant="head" bold sx={{ marginBottom: "16px", color: "#1a1a2e" }}>
// 					KYC process
// 				</Typo>

// 				<Spacer size="10px" />

// 				<Typo
// 					variant="text"
// 					sx={{
// 						color: "#64748b",
// 						lineHeight: "1.4",
// 					}}>
// 					//!TODO: description text here
// 				</Typo>

// 				<Spacer size="60px" />

// 				<Button
// 					variant="primary"
// 					title="Continue >"
// 					onClick={onNext}
// 					sx={{
// 						padding: "16px 48px",
// 						fontSize: "16px",
// 						fontWeight: "600",
// 						borderRadius: "12px",
// 						boxShadow: "0 0px 0px rgba(0, 0, 0, 0.1)",
// 						transition: "transform 0.2s, box-shadow 0.2s, background-color 0.4s",
// 						"&:hover": {
// 							transform: "translateY(-0px)",
// 							backgroundColor: "#0066ff",
// 							boxShadow: "0 3px 10px rgba(0, 0, 0, 0.4)",
// 						},
// 					}}
// 				/>
// 			</VBox>
// 		</VBox>
// 	);
// };

// declare interface IClientFormWebsite {
// 	id: number;
// 	general: {
// 		website_url_address: "";
// 		description: "";
// 		test_username: "";
// 		test_password: "";
// 		support_e_mail: "";
// 		support_phone: "";
// 	};
// 	payment_methods: {
// 		visa: false;
// 		mastercard: false;
// 		openbanking: false;
// 	};
// }

const Step_Websites = ({ onStepSuccess, onBack, stepIndex, clientID }: IStepViewProps) => {
	useLocale();
	const [websites, setWebsites] = useState<IClientGroup[]>([]);
	const [showAddForm, setShowAddForm] = useState<{ id: number } | null>(null);
	const [busySubmit, setBusySubmit] = useState(false);
	const [busyLoad, setBusyLoad] = useState(true);
	const contentRef = useRef<HTMLDivElement>(null);
	const [error, setError] = useState<IError | null>(null);

	useEffect(() => {
		if (busyLoad || busySubmit) {
			(contentRef.current as HTMLElement)?.scrollTo(0, 0);
		}
	}, [busyLoad, busySubmit]);

	const fetchWebsites = async () => {
		setError(null);
		setBusyLoad(true);

		const response = await GD.REQ_API.request({
			method: "merchants/list",
			data: {
				client_id: clientID,
			},
		});

		if (response.error) {
			setBusyLoad(false);
			setError(response.error);
			return;
		}

		if (response && response.data && Array.isArray(response.data)) {
			setWebsites(response.data.filter((w: any) => w.status !== "deleted" && w.id > 0));
		}

		setBusyLoad(false);
	};

	useEffect(() => {
		fetchWebsites();
	}, [clientID]);

	const onNext = () => {
		onStepSuccess();
	};

	const handleEditComplete = (updated: boolean) => {
		setShowAddForm(null);
		updated && fetchWebsites();
	};

	const handleRemoveWebsite = async (website: IClientGroup) => {
		if (!busyLoad && !busySubmit) {
			setBusySubmit(true);
			const response = await GD.REQ_API.request({
				method: "clients/group/status/change",
				data: {
					group_id: website.id,
					client_id: clientID,
					status: "deleted",
					reason: "Removed by user during registration process",
				},
			});

			if (response.error) {
				setError(response.error);
			}
			setBusySubmit(false);
			fetchWebsites();
		}
	};

	return (
		<Box ref={contentRef} sx={{ overflowY: busyLoad || busySubmit ? "hidden" : "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					padding: "10px",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					opacity: busyLoad ? 0 : 1,
					transition: "opacity 0.3s ease-in-out",
				}}>
				<Spacer size="20px" />

				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#1a1a2e" }}>{msg("companyWebsites")}</Typo>

				{error && (
					<>
						<Spacer size="10px" />
						<Error error={error} />
					</>
				)}

				<Spacer size="10px" />

				{websites.length === 0 && !showAddForm ? (
					<WebsiteEmptyBlock onAddClick={() => setShowAddForm({ id: 0 })} onBack={() => onBack && onBack(stepIndex)} />
				) : (
					<VBox sx={{ width: "100%", maxWidth: "700px", gap: "12px" }}>
						{!showAddForm &&
							websites.map((website, index) => (
								<WebsiteCard
									key={index}
									website={website}
									onRemove={() => handleRemoveWebsite(website)}
									onEdit={() => setShowAddForm({ id: website.id })}
								/>
							))}

						{showAddForm ? (
							<WebsiteAddForm
								clientID={clientID}
								websiteId={showAddForm.id}
								onComplete={handleEditComplete}
								label={showAddForm.id > 0 ? msg("editWebsite") : msg("addNewWebsite")}
								buttonTitle={showAddForm.id > 0 ? msg("saveChanges_35322b5b") : msg("addWebsite")}
							/>
						) : (
							<>
								<Spacer size="10px" />
								<Button
									variant="secondary"
									title={msg("addAnotherWebsite")}
									onClick={() => setShowAddForm({ id: 0 })}
									sx={{
										padding: "12px 24px",
										alignSelf: "center",
									}}
								/>
							</>
						)}

						{websites.length > 0 && !showAddForm && (
							<>
								<Spacer size="20px" />
								<StepButtons onStepSuccess={onNext} onBack={() => onBack && onBack(stepIndex)} />
							</>
						)}
					</VBox>
				)}

				<Spacer size="20px" />
			</VBox>

			{(busyLoad || busySubmit) && <StepPreloader />}
		</Box>
	);
};

const WebsiteEmptyBlock = ({ onAddClick, onBack }: { onAddClick: () => void; onBack?: () => void }) => {
	useLocale();
	return (
		<VBox
			sx={{
				alignItems: "center",
				justifyContent: "center",
				padding: "60px 40px",
				backgroundColor: "#f8fafc",
				borderRadius: "16px",
				border: "2px dashed #cbd5e1",
				maxWidth: "600px",
				width: "100%",
			}}>
			<Box
				sx={{
					width: "80px",
					height: "80px",
					borderRadius: "50%",
					backgroundColor: "#e0f2fe",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					marginBottom: "24px",
				}}>
				<IconPerson color="#0369a1" />
			</Box>

			<Typo variant="headMedium" bold sx={{ color: "#1e293b", marginBottom: "12px", textAlign: "center" }}>{msg("noWebsitesAddedYet")}</Typo>

			<Typo variant="text" sx={{ color: "#64748b", lineHeight: "1.6", textAlign: "center", marginBottom: "32px", maxWidth: "400px" }}>{msg("pleaseAddAtLeastOneWebsiteToProceedWithTheRegistrationWebsit_44916af9")}</Typo>

			<Box
				sx={{
					backgroundColor: "#fffbeb",
					border: "1px solid #fcd34d",
					borderRadius: "12px",
					padding: "16px 24px",
					marginBottom: "32px",
					maxWidth: "450px",
				}}>
				<HBox sx={{ alignItems: "center", gap: "12px" }}>
					<IconAttention color="#b45309" />
					<Typo variant="text" sx={{ color: "#92400e" }}>{msg("atLeastOneWebsiteIsRequiredToCompleteTheRegistrationProcess")}</Typo>
				</HBox>
			</Box>

			{/* //!TODO: gap value; */}
			<HBox sx={{}} gap="16px">
				{onBack && <BackButton onClick={onBack} />}
				<NextButton onClick={onAddClick} title={msg("addWebsite_3bad61e1")} />
			</HBox>
		</VBox>
	);
};

const WebsiteCard = ({ website, onRemove, onEdit }: { website: IClientGroup; onRemove: () => void; onEdit: () => void }) => {
	useLocale();
	//!TODO: colors, styles;
	return (
		<HBox
			sx={{
				backgroundColor: "#ffffff",
				borderRadius: "12px",
				padding: "20px 24px",
				boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
				border: "1px solid #e2e8f0",
				alignItems: "center",
				gap: "10px",
			}}>
			<VBox sx={{ flexGrow: 1 }}>
				<Typo variant="medium" bold sx={{ color: "#1e293b" }}>
					{website.domain ?? ""}
				</Typo>
				<Typo variant="small" sx={{ color: "#64748b" }}>
					{website.description ?? ""}
				</Typo>
			</VBox>

			<Spacer grow />

			<HBox gap="6px" sx={{ alignItems: "center" }}>
				{website.visa_enabled && <IconVisa />}
				{website.mastercard_enabled && <IconMastercard />}
				{website.openbanking_enabled && (
					//!TODO: open banking icon;
					<Typo variant="small" sx={{ color: "#64748b" }}>{msg("openBanking")}</Typo>
				)}
			</HBox>

			<Button
				variant="secondary"
				title={msg("edit")}
				onClick={onEdit}
				sx={{
					padding: "8px 16px",
					color: "#2657dc",
					borderColor: "#cae7fe",
					"&:hover": {
						backgroundColor: "#f2fafe",
						borderColor: "#2657dc",
					},
				}}
			/>

			<Button
				variant="secondary"
				title={msg("remove")}
				onClick={onRemove}
				sx={{
					padding: "8px 16px",
					color: "#dc2626",
					borderColor: "#fecaca",
					"&:hover": {
						backgroundColor: "#fef2f2",
						borderColor: "#dc2626",
					},
				}}
			/>
		</HBox>
	);
};

const WebsiteAddForm = ({
	clientID,
	websiteId,
	onComplete,
	label,
	buttonTitle,
}: {
	clientID: number;
	websiteId: number;
	onComplete: (update: boolean) => void;
	label: string;
	buttonTitle: string;
}) => {
	useLocale();
	return (
		<VBox
			sx={{
				backgroundColor: "#f0f9ff",
				borderRadius: "12px",
				padding: "24px",
				border: "2px solid #0ea5e9",
			}}>
			<Typo variant="medium" bold sx={{ color: "#0369a1", marginBottom: "20px" }}>
				{label}
			</Typo>

			<FormParser
				key="step_3_form"
				onSubmit={async (data: any) => {
					//	setBusy(true);
					const response = await GD.REQ_API.request({
						method: "clients/group/add",
						data: data,
					});
					if (response && response.data && response.data.data) {
						onComplete(true);
					}
					//	setBusy(false);
					return response;
				}}
				//!TODO: all buttons font size;
				secondaryButton={{
					variant: "secondary",
					title: msg("cancel"),
					onClick: () => onComplete(false),
					sx: {
						fontSize: "16px",
						padding: "10px 24px",
					},
				}}
				primaryButton={{
					variant: "primary",
					title: buttonTitle,

					sx: {
						padding: "10px 24px",
						backgroundColor: "#0066ff",
						color: "#FFFFFF",
						fontSize: "16px",
						"&:hover": {
							backgroundColor: "#0052cc",
						},
					},
				}}
				onRequest={async () => {
					//	setBusy(true);
					const response = await GD.REQ_API.request({
						method: "clients/group/get",
						data: {
							client_id: clientID,
							group_id: websiteId,
						},
					});

					//		setBusy(false);
					return response;
				}}
			/>
		</VBox>
	);
};

const Step_ReviewAndConsents = ({ onStepSuccess, clientID }: IStepViewProps) => {
	useLocale();
	const [busySubmit, setBusySubmit] = useState(false);
	const [busyLoad, _setBusyLoad] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);
	const [showForm, setShowForm] = useState(false);
	const [dataProcessing, setDataProcessing] = useState(false);
	const [privacy, setPrivacy] = useState(false);
	const [general, setGeneral] = useState(false);
	const [warrant, setWarrant] = useState(false);
	const [error, setError] = useState<IError>();

	useEffect(() => {
		if (busyLoad || busySubmit) {
			(contentRef.current as HTMLElement)?.scrollTo(0, 0);
		}
	}, [busyLoad, busySubmit]);

	const sendApplication = async () => {
		//setError(undefined);
		setBusySubmit(true);
		const response = await GD.REQ_API.request({
			method: "clients/form/submit",
			data: {
				client_id: clientID,
			},
		});
		if (response) {
			if (response.data) {
				setError(undefined);
				onStepSuccess();
			} else if (response.error) {
				setError(response.error);
			}
		}

		setBusySubmit(false);
	};

	return (
		<VBox
			ref={contentRef}
			sx={{ padding: "30px", overflowY: busyLoad || busySubmit ? "hidden" : "auto", height: "100%", width: "100%", position: "relative" }}>
			<VBox
				sx={{
					alignSelf: "center",
					padding: "10px",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					opacity: busyLoad ? 0 : 1,
					maxWidth: "800px",
					transition: "opacity 0.3s ease-in-out",
				}}>
				<Spacer size="20px" />
				<Typo variant="head" bold sx={{ display: "flex", alignSelf: "center", marginBottom: "16px", color: "#575761" }}>{msg("reviewAndConsents")}</Typo>
				<Typo variant="text" sx={{ color: "#475569", maxWidth: "600px", textAlign: "center", marginBottom: "16px" }}>{msg("pleaseVerifyingTheInformationBelowBeforeSubmittingYourApplic_41a1c1da")}</Typo>

				{error && (
					<>
						<Spacer size="10px" />
						<Error sx={{ minWidth: "300px" }} error={error} />
					</>
				)}

				<Spacer size="30px" />

				<HBox
					sx={{
						width: "100%",
						padding: "20px",
						borderRadius: "10px",
						backgroundColor: "#f0f9ff",
						border: "2px solid #0ea5e9",
						alignItems: "center",
					}}>
					<Typo variant="text" sx={{ color: "#475569", maxWidth: "600px", textAlign: "center" }}>{msg("application")}</Typo>
					<Button variant="secondarySmall" title={msg("view")} sx={{ marginLeft: "auto" }} onClick={() => setShowForm(true)} />
				</HBox>

				{showForm && (
					<Panel
						contentPadding="0px"
						scrollable
						growContent
						decorator="absolute"
						label={msg("applicationFormDetails")}
						onClose={() => setShowForm(false)}
						sx={{ maxHeight: "90vh", maxWidth: "90vw", overflow: "clip", minWidth: "600px" }}>
						<Box sx={{ padding: "20px", backgroundColor: "#e3ebee" }}>
							<FormParser
								previewMode={true}
								key="info_request"
								onSubmit={async (data: any) => {
									const response = await GD.REQ_API.request({
										method: "clients/form/set",
										data: data,
									});
									if (response && response.data && response.data.data) {
										mergeObject(response.data.data, clientInfoFormDecorator);
									}

									return response;
								}}
								onRequest={async () => {
									const response = await GD.REQ_API.request({
										method: "clients/form/get",
										data: {
											target_id: clientID,
											target_type: "client",
											type: "client_info",
										},
									});

									if (response && response.data && response.data.data) {
										mergeObject(response.data.data, clientInfoFormDecorator);
									}

									return response;
								}}
							/>
							<Spacer size="10px" />
						</Box>
					</Panel>
				)}

				<Spacer size="10px" />
				<FormOutline>
					<VBox gap="10px" sx={{ maxWidth: "800px" }}>
						{/* //!TODO: style; */}
						<Box
							sx={{
								padding: "20px",
								backgroundColor: "#FFFFFF",
								borderRadius: "6px",
								boxShadow: "0px 1px 2px rgba(0,0,0,.2)",
								display: "grid",
								gap: "10px",
							}}>
							<Checkbox
								sx={{}}
								checked={dataProcessing}
								onChange={selected => setDataProcessing(selected)}
								label={
									msg("iHerebyConsentToImpayaPaymentsLtdTheCompanyProcessingMyPerso_5bcaae31") +
									msg("assessingAndVerifyingThisApplication") +
									msg("concludingAndPerformingTheAgreement") +
									msg("complyingWithApplicableLegalAndRegulatoryRequirementsAnd") +
									msg("providingTheServicesIHaveRequested") +
									msg("iAcknowledgeThatTheProcessingOfMyPersonalDataWillBeCarriedOu_26ff9de3")
								}
							/>
						</Box>

						<Box
							sx={{
								padding: "20px",
								backgroundColor: "#FFFFFF",
								borderRadius: "6px",
								boxShadow: "0px 1px 2px rgba(0,0,0,.2)",
								display: "grid",
								gap: "10px",
							}}>
							<Checkbox
								sx={{}}
								checked={privacy}
								onChange={selected => setPrivacy(selected)}
								label={
									msg("iConfirmThatIHaveReadUnderstoodAndAgreeToBeBoundByThePrivacy_272f240c")
								}
							/>
						</Box>

						<Box
							sx={{
								padding: "20px",
								backgroundColor: "#FFFFFF",
								borderRadius: "6px",
								boxShadow: "0px 1px 2px rgba(0,0,0,.2)",
								display: "grid",
								gap: "10px",
							}}>
							<Checkbox
								sx={{}}
								checked={general}
								onChange={selected => setGeneral(selected)}
								label={
									msg("iHerebyConfirmThatIHaveReadUnderstoodAndAgreeToBeBoundByTheG_17a123cb")
								}
							/>
						</Box>

						<Box
							sx={{
								padding: "20px",
								backgroundColor: "#FFFFFF",
								borderRadius: "6px",
								boxShadow: "0px 1px 2px rgba(0,0,0,.2)",
								display: "grid",
								gap: "10px",
							}}>
							<Checkbox
								sx={{}}
								checked={warrant}
								onChange={selected => setWarrant(selected)}
								label={
									msg("bySigningThisApplicationFormIHereby") +
									msg("confirmThatAllInformationAndDocumentationProvidedInOrTogethe_128cf46f") +
									msg("warrantThatIHaveNotWithheldAnyMaterialInformationThatMayAffe_c341e1de") +
									msg("acknowledgeThatTheCompanyIsRelyingOnTheAccuracyOfTheInformat_0eed03ee") +
									msg("undertakeToPromptlyNotifyTheCompanyInWritingOfAnyChangesToTh_efc74ef9") +
									msg("ui_6e44322663")
								}
							/>
						</Box>

						<Spacer size="10px" />
						<HBox gap="20px" sx={{ alignSelf: "center" }}>
							<Link title={msg("privacyPolicy")} value={"https://google.com"} sx={{ color: "#0066ff" }} />
							<Link title={msg("termsAndConditions")} value={"https://google.com"} sx={{ color: "#0066ff" }} />
						</HBox>

						<Spacer size="10px" />
						<NextButton onClick={sendApplication} title={msg("submitApplication")} />
					</VBox>
				</FormOutline>
			</VBox>

			{(busyLoad || busySubmit) && <StepPreloader />}
		</VBox>
	);
};

const Step_9 = ({}: IStepViewProps) => {
	useLocale();
	return (
		<VBox
			sx={{
				padding: "40px",
				flex: 1,
				alignItems: "center",
				justifyContent: "center",
				display: "flex",
				overflowY: "auto",
			}}>
			<VBox
				sx={{
					alignContent: "center",
					alignItems: "center",
					maxWidth: "600px",
					textAlign: "center",
					padding: "60px",
					backgroundColor: "#ffffff",
					borderRadius: "10px",
					boxShadow: "0 3px 6px rgba(0, 0, 0, 0.08)",
				}}>
				<Box
					sx={{
						width: "80px",
						height: "80px",
						borderRadius: "50%",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}>
					<IconTitle color="#ff9100" />
				</Box>

				<Typo variant="head" bold sx={{ marginBottom: "16px", color: "#1a1a2e" }}>{msg("success")}</Typo>

				<Spacer size="10px" />

				<Typo
					variant="text"
					sx={{
						color: "#64748b",
						lineHeight: "1.4",
					}}>{msg("thankYouForCompletingTheRegistrationProcessYourInformationHa_4591f33c")}</Typo>

				<Spacer size="60px" />

				{/* <Button
					variant="primary"
					title="Start Again"
					onClick={onStepSuccess}
					sx={{
						padding: "16px 48px",
						fontSize: "16px",
						fontWeight: "600",
						borderRadius: "12px",
						boxShadow: "0 0px 0px rgba(0, 0, 0, 0.1)",
						transition: "transform 0.2s, box-shadow 0.2s, background-color 0.4s",
						"&:hover": {
							transform: "translateY(-0px)",
							backgroundColor: "#0066ff",
							boxShadow: "0 3px 10px rgba(0, 0, 0, 0.4)",
						},
					}}
				/> */}
			</VBox>
		</VBox>
	);
};
